import React from 'react';
import PropTypes from 'prop-types';
import InputText from '../../Common/InputText';
import Toggle from '../../Common/Toggle/Toggle';

export default class ManagementCompanyForm extends React.Component {

    constructor(props, context) {
        super(props, context);

    }

    onTextChange = (e) => {
        this.props.onFormChange(e.target.name, e.target.value);
    }

    onToggleChange = (name, value) => {
        this.props.onFormChange(name, value);
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit();
        return false;
    }

    render() {

        return (
            <div className="identifier-form">
                <form noValidate className={this.props.isFormValid ? "" : "was-validated"} onSubmit={this.onSubmit}>
                    <InputText name="name" label="Name" placeholder="Name" type="text" value={this.props.managementCompany.name} onChange={this.onTextChange} isRequired={true} errorMessage="Name is required" maxLength={100} />
                    <InputText name="companyCode" label="Code" placeholder="Code" type="text" value={this.props.managementCompany.companyCode} onChange={this.onTextChange} isRequired={false} maxLength={100} />
                    <Toggle name="isActive" text="Active" checked={this.props.managementCompany.isActive} onChange={this.onToggleChange} />
                    <input type="submit" className="d-none" />
                </form>
            </div>
        );
    }

}

ManagementCompanyForm.propTypes = {
    onFormChange: PropTypes.func.isRequired, // returns (field, value)
    isFormValid: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    managementCompany: PropTypes.object
}
